<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Marketing Staffs",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Marketing Staffs",
            items: [
               {
                  text: "Marketing Staffs",
                  active: true,
               },                   
            ],            

            staffs: [],          
            
            from: null,
            to: null,
            total: null,
            pagination: {},
            staff_status: {
               id: "",
               status: "",
            },
            listing_length: 10,
            keyword: '',
            status: '',
            token: "",
            errors: {},
            activate: false,
            deactivate: false,

            active_page_url: null,
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchStaffs();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
         fetchStaffs(page_url = null) {

            this.getToken();
            let url = "api/admin/marketingstaff?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.staffs = responseData.marketing_staffs.data;
                  
                  this.pagination = responseData.marketing_staffs.links;
                  this.from = responseData.marketing_staffs.from;
                  this.to = responseData.marketing_staffs.to;
                  this.total = responseData.marketing_staffs.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         activateStaff(staff) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this staff?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.staff_status.id = staff.id;
                  this.staff_status.status = 1;
                  this.updateStaffStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateStaff(staff) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this staff?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.staff_status.id = staff.id;
                  this.staff_status.status = 2;
                  this.updateStaffStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateStaffStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            let url = "api/admin/marketingstaff/status?marketing_staff_id=" + this.staff_status.id + "&status=" + this.staff_status.status;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchStaffs(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'marketingstaffs.add' }" class="btn btn-primary float-end">Add Marketing Staff</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchStaffs()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchStaffs()"/>
                           </label>
                        </div>  

                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchStaffs()">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                              </select>
                           </label>
                        </div>                          
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>SI No.</th>
                              <th>Name</th>                 
                              <th>Contact</th>  
                              <th>Whatsapp</th> 
                              <th>Referral Code</th>         
                              <th>Created on</th>
                              <th>Options</th>
                           </tr>
                        </thead>

                        <tbody v-if="Boolean(staffs.length)">
                           <tr v-for="(staff, index) in staffs" :key="staff.id">
                              <td>{{index + from}}</td>
                              <!-- <td>
                                 <img v-if="staff.id_proof" :src="$image_url + staff.id_proof" alt="" class="avatar-sm rounded-circle">
                                 <img v-else src="@/assets/images/no-user.jpg" class="avatar-sm rounded-circle">
                              </td> -->
                              <td>{{staff.name}}</td>
                              <td>
                                 +91 {{staff.mobile}}<br>
                                 {{staff.email}}
                              </td>
                              <td>+91 {{staff.whatsapp_number}}</td>
                              <td>{{staff.referral_code}}</td>
                              <td>{{staff.created_at | formatDateTime }}</td>
                              <td>
                                 <router-link :to="{ name: 'marketingstaffs.details', params: {id: staff.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>

                                 <router-link :to="{ name: 'marketingstaffs.edit', params: {id: staff.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Edit</router-link>

                                 <router-link :to="{ name: 'marketingstaffs.referrals', params: {id: staff.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Referrals</router-link>

                                 <b-button v-if="staff.status==1" variant="danger" class="btn-sm mb-2 me-2" @click="deactivateStaff(staff)">Unpublish</b-button>

                                 <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="activateStaff(staff)">Publish</b-button>
                              </td>
                           </tr>
                        </tbody>

                        <tbody v-else>
                           <tr>
                              <td colspan="6" class="text-center">No marketing staffs found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(staffs.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchStaffs(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->       

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
